import { Button } from "devextreme-react/button";
import { DateBox } from "devextreme-react/date-box";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import LoaderThreeDot from "../../Loader/LoaderThreeDot";
import axiosInstance from "../../Middleware/axiosInstance";

const SlotWrapper = styled.div`
  height: 77%;
  overflow-y: auto;
`;

const SlotAvailabilityContainer = styled.div`
width:100%;
padding:5px;
border:1px solid lightgrey;
`;

const SlotContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  ${"" /* border-bottom: 1px solid lightgrey; */}
  ${"" /* border-left: 1px solid lightgrey; */}
`;

const Time = styled.div`
  border: 1px solid lightgrey;
  padding: 5px 15px;
  border-radius: 3px;
  ${'' /* width: 23%; */}
  display: flex;
  align-items: center;
  margin: 5px;
  &:hover {
    cursor: pointer;
    background-color: lightgrey;
  }
`;

const LoadingText = styled.div`
  display: flex;
  height: 85%;
  justify-content: center;
  align-items: center;
`;

const SelectedTimeSlotContainer = styled.div`
width:100%;
display:flex;
align-items:center;
gap:10px;
padding:10px;
font-size:15px;
background:lightblue;
`

const BPSlotAvailabilityControl = ({slotSelectionHandler,conversationID, disableSlotSelectionControl}) => {
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
    const [availableSlotData, setAvailableSlotData] = useState({
        error_code: null,
        data: [],
        error_description: ""
    });
    const [isSlotFetching, setIsSlotFetching] = useState(false);
    const [isCalendarFetching, setIsCalendarFetching] = useState(false);

    const [slotAvailabilityStartAndEndDate, setSlotAvailabilityStartAndEndDate] = useState(null)
    const [slotUnavailabilityDates, setSlotUnavailabilityDates] = useState(null)
    const [firstAvailableSlotDate, setFirstAvailableSlotDate] = useState(null)
    useEffect(() => {
        console.log("Fetching availability dates.");
        setIsCalendarFetching(true);
        axiosInstance().get(`/oi/chatty/GetAvailabilityCalendar/${conversationID}`).then(
            (response) => {
                console.log(response);
                console.log("availability_calendar:", response.data?.availability_calendar)
                let slotAvailabilityDatesRawData = response.data?.availability_calendar
                if (slotAvailabilityDatesRawData) {
                    console.log(moment(slotAvailabilityDatesRawData[0].date));
                    console.log(moment(slotAvailabilityDatesRawData[slotAvailabilityDatesRawData.length - 1].date));

                    let unavailableDates = new Array()
                    let firstAvailabilityDate = null;
                    slotAvailabilityDatesRawData.map((obj, index) => {
                        console.log(obj);
                        if (obj?.isAvailable === false) {
                            unavailableDates.push(new Date(obj.date))
                        }
                        if (firstAvailabilityDate === null && obj?.isAvailable === true) {
                            firstAvailabilityDate = new Date(obj.date)
                        }

                    });


                    setSlotAvailabilityStartAndEndDate([moment(slotAvailabilityDatesRawData[0].date), moment(slotAvailabilityDatesRawData[slotAvailabilityDatesRawData.length - 1].date)])
                    setSlotUnavailabilityDates(unavailableDates)
                    setFirstAvailableSlotDate(firstAvailabilityDate)
                    setIsCalendarFetching(false);
                    if (firstAvailabilityDate != null) {
                        fetchAvailableSlots(firstAvailabilityDate);
                    }
                }
            }
        ).catch((error) => { console.error(error); setIsCalendarFetching(false); })

    }, [])


    const RenderSlots = ({ availableSlots }) => {
        return (
            <Fragment>
                {availableSlots?.length > 0 &&
                    availableSlots.map((slot) => (
                        <Time
                            onClick={() => {
                                if (disableSlotSelectionControl) return;
                                setSelectedTimeSlot(slot);
                                slotSelectionHandler(slot, false);
                            }}
                            style={{
                                background: selectedTimeSlot?.schedule === slot.schedule && "#2185D0",
                                color: selectedTimeSlot?.schedule === slot.schedule && "white",
                            }}
                        >
                            {/* <div
                                style={{
                                    borderRight: "1px solid ",
                                    marginRight: "5px",
                                    paddingRight: "5px",
                                }}
                            >
                                {slot?.room_name ? (
                                    <p
                                        style={{
                                            // fontSize: "1px",
                                            marginTop: "2px",
                                            marginBottom: "2px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {" "}
                                        {`${slot?.room_name}`}
                                    </p>
                                ) : (
                                    ""
                                )}
                            </div> */}
                            <div>
                                {moment(slot?.schedule).format("hh:mm A")}

                                {/* {slot?.slot_text ? (
                                    <p
                                        style={{
                                            fontSize: "12px",
                                            // marginTop: "2px",
                                            // fontWeight: "500",
                                        }}
                                    >
                                        {" "}
                                        {`${slot?.slot_text}`}
                                    </p>
                                ) : (
                                    ""
                                )} */}
                            </div>
                        </Time>
                    ))}
            </Fragment>
        );
    };


    const fetchAvailableSlots = (date) => {
        setIsSlotFetching(true);
        console.log("Fetching available slots for:", moment(date).format("yyyy-MM-DD"));
        axiosInstance().get(`/oi/chatty/GetAvailabilitySlots/${conversationID}?query_date=${moment(date).format("yyyy-MM-DD")}`).then((response) => {
            console.log(response)
            let error_code = response.data?.error_code;
            let error_description = response.data?.error_description;
            let slots_data = response.data?.availability_calendar;
            setAvailableSlotData({ error_code: parseInt(error_code), error_description: error_description, data: slots_data })
            setIsSlotFetching(false);

            slots_data.map((slot)=>{
                console.log(moment(slot.schedule).format("h:mm a"))
            })

        }).catch((error) => {
            console.log(error);
            setIsSlotFetching(false);
            setAvailableSlotData({ error_code: 500, error_description: error, data: null })

        })
    }
    return (
        <SlotAvailabilityContainer>
            {selectedTimeSlot && <SelectedTimeSlotContainer>
                <div style={{ marginRight: "10px", borderBottom: "1px solid lightgrey" }}>Schedule Datetime :</div>
                <div> {selectedTimeSlot?.schedule ? moment(selectedTimeSlot?.schedule).format("DD/MM/YYYY hh:mm A") : ""}</div>
                <div><Button text="Confirm" icon="arrowright" rtlEnabled={true} type="success" onClick={() => { slotSelectionHandler(selectedTimeSlot, true) }} disabled={disableSlotSelectionControl}></Button></div>
            </SelectedTimeSlotContainer>}
            {/* <DateTimeSelectionBar
                availableSlotListHandler={setAvailableSlotList}
                setIsSlotFetching={setIsSlotFetching}
                isSlotFetching={isSlotFetching}
            /> */}
            {/* Do not show date selection till slotAvailabilityDates is null */}
            <div style={{ marginTop: "10px" }}>{isCalendarFetching ? (
                <LoadingText>
                    <div style={{ display: "grid", gap: "10px", justifyItems: "center" }}>
                        <LoaderThreeDot />
                        <div style={{ fontSize: "16px" }}>Fetching calendar</div>
                    </div>
                </LoadingText>) : slotAvailabilityStartAndEndDate &&
            <DateBox
                type="date"
                label=" Date "
                placeholder="DD/MM/YYYY"
                useMaskBehavior={true}
                displayFormat="dd/MM/yyyy"
                height={45}
                // opened={true}
                value={firstAvailableSlotDate}
                min={slotAvailabilityStartAndEndDate[0]}
                max={slotAvailabilityStartAndEndDate[1]}
                onValueChanged={(e) => fetchAvailableSlots(e.value)}
                disabledDates={slotUnavailabilityDates} disabled={disableSlotSelectionControl} />
            }

            </div>
            <SlotWrapper>
                {isSlotFetching ? (
                    <LoadingText>
                        <div style={{ display: "grid", gap: "10px", justifyItems: "center" }}>
                            <LoaderThreeDot />
                            <div style={{ fontSize: "16px" }}>Fetching slots</div>
                        </div>
                    </LoadingText>
                ) : availableSlotData.error_code === 0 &&
                    availableSlotData.data?.length === 0 ? (
                    <LoadingText style={{ fontSize: "17px" }}>
                        {" "}
                    </LoadingText>
                ) : availableSlotData.error_code === 0 &&
                    availableSlotData.data?.length ? (
                    <Fragment>
                        <SlotContainer
                        // style={{
                        //     borderBottom:
                        //         availableSlotData?.data.length &&
                        //             availableSlotData.data.length - 1 !== index
                        //             ? "1px solid lightgrey"
                        //             : "unset",
                        // }}
                        >
                            <RenderSlots availableSlots={availableSlotData.data} />
                        </SlotContainer>
                    </Fragment>
                ) : availableSlotData.error_code !== 0 ? <LoadingText style={{ fontSize: "17px", color: "orange" }}>
                    {" "}
                    {availableSlotData?.error_description}
                </LoadingText> : ""}
            </SlotWrapper>
        </SlotAvailabilityContainer>
    )
}

export default BPSlotAvailabilityControl